<template>
  <div class="video">
    <!-- <video 
    width="100%" 
    controls 
    x5-playsinline='true'
    webkit-playsinline='true' 
    playsinline='true'
    preload="auto"
    > -->
    <video 
    width="100%" 
    controls 
    >
      <source src="http://www.cippe.com.cn/wx/video/1.mp4" type="video/mp4">
      <!-- <source src="movie.ogg" type="video/ogg"> -->
      您的浏览器不支持 video 标签。
    </video>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .video video{
    height: 190px;
  }
</style>